/// <amd-module name="Wit/Search/SearchFields" />
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { ITfsPageService } from "Tfs/Platform/Page";
import { WorkItemField } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import * as _WorkItemTrackingRestClient from "Wit/Clients/Wit/RestClient/WorkItemTracking.Types";

export interface IWorkItemTrackingSuggestionField {
    field: WorkItemField;

    shortcut?: string;
}

export namespace ShortcutFieldNames {
    export const AssignedTo: string = "system.assignedto";
    export const CreatedBy: string = "system.createdby";
    export const State: string = "system.state";
    export const WorkItemType: string = "system.workitemtype";
}

export const ShortcutTexts: { [key: string]: string } = {
    [ShortcutFieldNames.AssignedTo]: "a",
    [ShortcutFieldNames.CreatedBy]: "c",
    [ShortcutFieldNames.State]: "s",
    [ShortcutFieldNames.WorkItemType]: "t"
};

export namespace ValueSuggestions {
    export const Today: string = "@Today";
    export const Today1: string = "@Today-1";
    export const Today7: string = "@Today-7";
    export const Today30: string = "@Today-30";
}

export class WorkItemTrackingFieldService extends VssService {
    private fieldsPromise: Promise<IWorkItemTrackingSuggestionField[]>;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        const client = pageContext.getRestClient<_WorkItemTrackingRestClient.IWorkItemTrackingRestClient>("IWorkItemTrackingRestClient");
        const pageService = pageContext.getService<ITfsPageService>("ITfsPageService");
        const pageData = pageService.getData();
        const projectName = pageData && pageData.project ? pageData.project.name : "";

        this.fieldsPromise = client.getFields(projectName).then((fields: WorkItemField[]) => {
            return fields.map<IWorkItemTrackingSuggestionField>(field => {
                return {
                    field: field,
                    shortcut: ShortcutTexts[field.referenceName.toLowerCase()]
                };
            });
        });
    }

    public getFields(): Promise<IWorkItemTrackingSuggestionField[]> {
        return this.fieldsPromise;
    }
}

Services.add("WorkItemTrackingFieldService", { serviceFactory: WorkItemTrackingFieldService });
